import React, { useEffect, useState } from "react";

import { ReactComponent as HeartSVG } from "../../../assets/svg/suits/heart.svg";
import { ReactComponent as SpadeSVG } from "../../../assets/svg/suits/spades.svg";
import { ReactComponent as ClubSVG } from "../../../assets/svg/suits/club.svg";
import { ReactComponent as DiamondSVG } from "../../../assets/svg/suits/diamond.svg";
import { colors } from "../../../lib/colors";

export const GAME_DESCRIPTION = {
  title: "Video Poker",
  description: `Video poker is yet another revolutionary concept of simplicity developed by Orbital’s talented team.
  Video poker is highly customizable, yet an extremely easy game, in which you have complete control over your fate. Make Strategic decisions based on the card combinations. Hold the cards that make the most sense to you.
  Choose the “Gamble” option, where you can double or even Quadruple(4X) Your Winnings!
  If you hit the correct color you’ll get 2X on top of your win!
  If You’ll guess a Suit, You’ll get 4X! Enjoy the classic Video poker with a Twist!`,
};

export const useCardCombinations = (coefs: any[]) => {
  const [combArray, setCombArray] = useState<any[]>([]);
  useEffect(() => {
    coefs &&
      setCombArray([
        {
          combinationName: "Pair of Jacks or Better",
          coef: coefs[0],
          cards: [
            {
              name: "J",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "J",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "2",
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: false,
            },
            {
              name: "3",
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: false,
            },
            {
              name: "4",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: false,
            },
          ],
        },
        {
          combinationName: "Two pairs",
          coef: coefs[1],
          cards: [
            {
              name: "10",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "10",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "8",
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "8",
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "4",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: false,
            },
          ],
        },
        {
          combinationName: "Three of a kind",
          coef: coefs[2],
          cards: [
            {
              name: "10",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "10",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "10",
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "8",
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: false,
            },
            {
              name: "4",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: false,
            },
          ],
        },
        {
          combinationName: "Straight",
          coef: coefs[3],
          cards: [
            {
              name: "2",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "3",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "4",
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "5",
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "6",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
        {
          combinationName: "Flush",
          coef: coefs[4],
          cards: [
            {
              name: "2",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "10",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "4",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "7",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "A",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
        {
          combinationName: "Full house",
          coef: coefs[5],
          cards: [
            {
              name: "Q",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "Q",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "2",
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "2",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "2",
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
          ],
        },
        {
          combinationName: "Four of a kind",
          coef: coefs[6],
          cards: [
            {
              name: "Q",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "Q",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "Q",
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "Q",
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: "6",
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: false,
            },
          ],
        },
        {
          combinationName: "Straight flush",
          coef: coefs[7],
          cards: [
            {
              name: "A",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "2",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "3",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "4",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "5",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
        {
          combinationName: "Royal straight flush",
          coef: coefs[8],
          cards: [
            {
              name: "10",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "J",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "Q",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "K",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: "A",
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
      ]);
  }, [coefs]);

  return [combArray];
};
